export enum RootCollection {
  Configuration = 'config',
  Organisations = 'organisations',
  PracticeMigrations = 'practiceMigrations',
  ManagementJobs = 'managementJobs',
  ManagementStaff = 'managementStaff',
  ManagementUsers = 'managementUsers',
  ManagementApiLogs = 'managementApiLogs',
  Partners = 'partners',
  BigQueryUploadJobs = 'bigQueryUploadJobs',
  BigQueryUploadStats = 'bigQueryUploadStats',
  WorkspaceProvisioningTasks = 'workspaceProvisioningTasks',
  MigrationUploadCodes = 'migrationUploadCodes',
  MigrationUploadSessions = 'migrationUploadSessions',
  StripeEvents = 'stripeEvents',
  MigrationDatabaseInstances = 'migrationDatabaseInstances',
}

export enum ConfigDocuments {
  Public = 'public',
  DemoSpace = 'demo-space',
  Recaptcha = 'recaptcha',
  BigQueryUploads = 'bigQueryUploads',
}

export interface IDemoSpace {
  fileNames: string[];
}

export enum AppName {
  Principle = 'principle',
  Partners = 'principle-partners',
  Referrals = 'principle-referrals',
  Admin = 'principle-admin',
}

export interface IPublicConfig {
  version: string;
  versions?: Partial<Record<AppName, string>>;
}

export interface IBigQueryUploadsConfig {
  dryRun: boolean;
  maxJobs: number;
  maxJobSize: number;
  enableTimingLogs?: boolean;
}
